import {isString} from '~ui/utils';

interface OrganizationIdsSettings {
    // Now we use cloudOrgId instead of orgId, not to mix context with cloud console/org
    cloudOrgId?: string;
    directoryOrgId?: string;
    collabOrgId?: string;
}

export const redirectToContextUrl = (
    sk: string,
    orgId: string | OrganizationIdsSettings,
    retpath?: string,
) => {
    const url = new URL('/.organization/context', window.location.origin);

    url.searchParams.set('sk', sk);

    if (isString(orgId)) {
        url.searchParams.set('org_id', JSON.stringify({directoryOrgId: orgId}));
    } else {
        url.searchParams.set('org_id', JSON.stringify(orgId));
    }

    url.searchParams.set('mode', 'portal');
    url.searchParams.set('retpath', retpath || window.location.href);

    window.location.assign(url.href);
};
